import React from 'react'
import '../otherpage.css'

const Term_Condition_Content = () => {
  return (
    <div className="container terms-container">
            <h2>Terms and Conditions</h2>
            <p>
                Welcome to Harsafe Technology Finance Service Pvt. Ltd. By accessing or using our app, you agree to abide by the following terms and conditions. Please read them carefully.
            </p>

            <h3>1. Acceptance of Terms</h3>
            <p>
                By using this app, you confirm your agreement to be bound by these terms and conditions. If you disagree with any part of the terms, you may not use the app.
            </p>

            <h3>2. Use of Services</h3>
            <p>
                You agree to use the services provided by Harsafe Technology Finance Service Pvt. Ltd. only for lawful purposes and in a manner that does not infringe the rights of or restrict or inhibit anyone else’s use of the app.
            </p>

            <h3>3. Privacy Policy</h3>
            <p>
                Our Privacy Policy outlines how we handle your personal data. By using this app, you agree to the collection and use of information in accordance with our Privacy Policy.
            </p>

            <h3>4. Financial Disclaimer</h3>
            <p>
                Harsafe Meet (HSMeet), including its Hisab Book and related record-keeping features, is provided solely as a communication, collaboration, and bookkeeping tool. It is not a bank, non-banking financial company (NBFC), payment processor, or licensed financial institution, and does not provide financial, investment, tax, or accounting advice.
            </p>
            <p>
                Harsafe Technology Finance Service Pvt. Ltd. does not guarantee the accuracy, completeness, or reliability of any financial records, transactions, entries, or data that users create, store, or share through the app. All records maintained using the app are user-generated and are the sole responsibility of the user. You are responsible for independently verifying and reconciling your own financial data, and should consult a qualified professional for financial or accounting advice.
            </p>

            <h3>5. Limitation of Liability</h3>
            <p>
                Harsafe Technology Finance Service Pvt. Ltd. shall not be liable for any damages arising out of your use of the app or inability to access or use the services, including any loss or damage arising from reliance on financial records or data maintained through the app.
            </p>

            <h3>6. Modifications to Terms</h3>
            <p>
                We reserve the right to modify these terms at any time. Your continued use of the app following any changes indicates your acceptance of the new terms.
            </p>

            <h3>7. User Responsibilities</h3>
            <p>
                You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account.
            </p>

            <h3>8. Termination</h3>
            <p>
                We reserve the right to terminate or suspend your account and access to the app without prior notice or liability, for any reason whatsoever, including, without limitation, if you breach the Terms.
            </p>

            <h3>9. Indemnification</h3>
            <p>
                You agree to indemnify, defend, and hold harmless Harsafe Technology Finance Service Pvt. Ltd. and its affiliates, partners, and employees from any claims, losses, liabilities, damages, costs, or expenses (including reasonable attorney's fees) arising from your use of the app or violation of these terms.
            </p>

            <h3>10. Governing Law</h3>
            <p>
                These Terms and Conditions shall be governed by and construed in accordance with the laws of [Your Country/State]. Any disputes arising out of or related to these terms shall be subject to the exclusive jurisdiction of the courts in [Your Location].
            </p>

            <h3>11. Contact Us</h3>
            <p>
                If you have any questions about these Terms and Conditions, please contact us at:
                <br />
                <strong>Email:</strong> info@harsafe.com
            </p>

            <p className="terms-footer">
                If you have any questions about these Terms and Conditions, please contact us.
            </p>
        </div>
  )
}
export default Term_Condition_Content